/**
 * @author SwathiDivya Bhavaraju
 * @email swathidivya.bhavaraju@ul.com
 * @create date 2020-04-20 16:31:43
 * @modify date 2020-04-20 16:31:43
 * @desc [description]
 */
import axios from 'axios';
import FileSaver from 'file-saver';
import b64toBlob from '../utils/base64toBlob';
/**
 * newRegiUploadFiles post api
 * to upload the attahcments of registrations */
export async function uploadRegiAttachments(data, regiId) {
  let result = [];
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/attachments/${regiId}`, data)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('attachments java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * newRegiUploadFiles delete api
 * to delete the attahcments of registrations */
export async function deleteAttachments(formData) {
  console.log('data', formData);
  const url = `${process.env.VUE_APP_JAVA_API_URL}/attachments`;
  let result = '';
  await axios
    .delete(url, { data: formData })
    .then((response) => {
      if (response.status === 200 && response.data) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('attachments java api error', err);
    });
  return result;
}
/**
 * newRegiUploadFiles put api
 * to update the attahcments of registrations */
export async function updateFile(regiId, data, version) {
  let result = [];
  const dataObj = {};
  dataObj.data = data;
  dataObj.revision = version;
  await axios
    .put(`${process.env.VUE_APP_JAVA_API_URL}/attachments/${regiId}`, dataObj)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('attachments java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * newRegiUploadFiles put api
 * to update the attahcments of registrations */
export async function checkFileConfidentiality(regiId, data, version) {
  let result = [];
  const dataObj = {};
  dataObj.data = data;
  dataObj.revision = version;
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/attachments_update/${regiId}`, dataObj)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('attachments java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * get files get api
 * to get the attahcments of registrations */
export async function getAttachments(regiId) {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/attachments/${regiId}`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('attachments java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * download files get api
 * to download the attahcments of registrations */
export async function downloadFile(regId, file) {
  const url = `${process.env.VUE_APP_JAVA_API_URL}/attachments_download/${regId}/${file.attachmentId}`;
  let result = '';
  await axios
    .get(url)
    .then((response) => {
      if (response.status === 200 && response.data) {
        result = response.data;
        const blob = b64toBlob(
          result,
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        );
        FileSaver.saveAs(blob, file.fileName);
      }
    })
    .catch((err) => {
      console.log('download file java api error', err);
    });
  return result;
}
